import React from 'react'

function RaiseTicket() {
    return (  
        <div className='container'>
            <div className='row p-5 mt-5 mb-5'>
                <h1 className='fs-2 text-muted'>
                    To create a ticket , select a relevant topic 
                </h1>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4>Account Opening</h4>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Getting started</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Online</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Offline</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Charges</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Company, Partnership and HUF</a><br></br>
                    <a href='#' style={{textDecoration:"none", lineHeight:"2.5"}}>Non Resident Indian (NRI)</a><br></br>
                </div>
            </div>
        </div>
    );
}

export default RaiseTicket;